import {createBasicSelectors, makeSelect} from '../../utils/redux'
import {initialState} from './constants'
import {AuthState} from './types'

const select = makeSelect<AuthState>('auth')

export const basicSelectors = createBasicSelectors<AuthState>(initialState, select)
